"use client";

import { useContext, useMemo, useEffect, useState } from "react";
import styles from './_hcp-header.module.scss';
import Link from "next/link";
import CustomImage from "@/components/image";
import { LayoutContext } from "@/components/layout-context-container";
import HcpHeaderNav from "./components/header-nav";
// import HomeConferenceBanner from "@/page-components-hcp/homepage/components/home-conference-banner";

export default function HcpHeader({ navDisabled = false, navDisabledLogoCentered = false, isSticky = false }) {
  const [scrollingDown, setScrollingDown] = useState(false);
  const {isHcpRoute, showMobileMenu, setShowMobileMenu} = useContext(LayoutContext);
  const linkHome = '/';
  const containerClass = useMemo(() => {
    let className = styles.container;

    if (navDisabledLogoCentered) {
      className = `${className} ${styles.logo_centered}`;
    }

    if (isSticky) {
      className = `${className} ${styles.sticky}`;
    }

    return className;
  }, [navDisabledLogoCentered, isSticky])


  useEffect(() => {
    function onScroll() {
      const stickyEl = document.querySelector('.sticky-header');
      if (stickyEl) {
        (!scrollingDown || window.scrollY <= 1) && setScrollingDown(window.scrollY > parseFloat(getComputedStyle(stickyEl).height.replace('px','')));
      } else {
        setScrollingDown(false);
      }
    }
    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    onScroll();
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [scrollingDown]);

  return (
    <>
      {/* <HomeConferenceBanner /> */}
      <div className={`container ${styles.message_mobile} ${isSticky ? styles.sticky_message_mobile : ''} ${scrollingDown ? styles.sticky_message_scrolled_down : ''} ${showMobileMenu ? styles.show_mobile_menu : ''}`}>
        This site is intended for US healthcare professionals only.
      </div>
      {/* <HomeConferenceBanner mobileOnly={true} /> */}
      <header className={`${containerClass} hcp-header ${scrollingDown ? styles.scrolled_down : ''} ${showMobileMenu ? styles.show_mobile_menu : ''}`}>
        <div className={styles.container_wrapper}>
          <div className={`${styles.nav_wrapper} container`}>
            <div className={styles.logo}>
              <Link
                href={linkHome}
                data-gtm-event-category="Header"
                data-gtm-event-action="Click"
                data-gtm-event-label="Crenessity Logo"
                onClick={() => setShowMobileMenu(false)}
              >
                <CustomImage
                  src="/images/logos/hcp/Crenessity-Logo.svg"
                  width={154}
                  height={85}
                  style={{
                    width: '154px',
                    height: 'auto',
                  }}
                  priority
                  alt="Crenessity logo, click to visit homepage"
                />
              </Link>
            </div>
            {!navDisabled && !navDisabledLogoCentered && <HcpHeaderNav />}
          </div>
        </div>
        {!navDisabled && !navDisabledLogoCentered && <HcpHeaderNav mobile />}
      </header>
    </>
  );
}